// #region Global Imports
import { DefaultTheme } from 'styled-components';
// #endregion Global Imports

const theme: DefaultTheme = {
  /**
   * Font
   */
  app: {
    padding: {
      vertical: '12px',
      horizontal: '18px',
    },
    tabs: {
      padding: {
        vertical: '12px',
        horizontal: '24px',
      },
    },
    icon: {
      size: 18,
      color: '#1f2328',
    },
  },
  button: {
    height: {
      xs: '32px',
      sm: '36px',
      md: '40px',
      lg: '44px',
    },
    icon: {
      xs: 32,
      sm: 36,
      md: 40,
      lg: 44,
    },
  },
  datePicker: {
    height: {
      xs: '32px',
      sm: '36px',
      md: '40px',
      lg: '44px',
    },
  },
  select: {
    height: {
      xs: '32px',
      sm: '36px',
      md: '40px',
      lg: '44px',
    },
  },
  input: {
    height: {
      xs: '32px',
      sm: '36px',
      md: '40px',
      lg: '44px',
    },
  },
  modal: {
    width: {
      xxs: '420px',
      xs: '560px',
      sm: '600px',
      md: '840px',
      lg: '1200px',
      xl: '1440px',
    },
    height: {
      xxs: '200px',
      xs: '300px',
      sm: '400px',
      md: '500px',
      lg: '700px',
      xl: '1000px',
    },
  },
  tab: {
    padding: {
      paddingVertical: '12px',
      paddingHorizontal: '36px',
    },
  },
  avatar: {
    size: {
      xs: 32,
      sm: 36,
      md: 42,
      lg: 48,
    },
  },
  font: {
    // family: `'Work Sans', sans-serif`,
    family: `var(--font-sans)`,
    weight: {
      light: '300',
      normal: '400',
      regular: '500',
      medium: '500',
      bold: '600',
      extraBold: '700',
    },
    size: {
      small: '9px',
      tiny: '11px',
      xxs: '12px',
      xs: '13px',
      sm: '14px',
      md: '18px',
      lg: '24px',
      xl: '32px',
    },
  },

  /**
   * Colors
   */
  colors: {
    black: '#000000',
    white: '#fff',
    success: '#26B75D',
    body: '#F2F3F7',
    price: '#EB403D',
    startFill: '#F8961E',

    primary: {
      light: '#26B75D',
      main: '#26B75D',
      dark: '#1f2328',
      grey: '#BDBDBD',
      contrastText: '#fff',
    },

    secondary: {
      light: '#ff4081',
      main: '#f50057',
      dark: '#c51162',
      contrastText: '#fff',
    },

    icon: {
      primary: '#59636E',
      secondary: '#59636E',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
      lightGreen: '#7CB305',
      green: '#26B75D',
      red: '#EB403D',
      price: '#EB403D',
      link: '#1890FF',
      lightOrange: '#F8961E',
      orange: '#FF6347',
      white: '#fff',
      main: '#26B75D',
      dark: '#17431D',
      black: 'black',
    },

    text: {
      primary: '#1f2328',
      secondary: '#59636E',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)',
      lightGreen: '#7CB305',
      green: '#26B75D',
      red: '#EB403D',
      price: '#EB403D',
      link: '#1890FF',
      lightOrange: '#F8961E',
      orange: '#FF6347',
      white: '#fff',
      main: '#26B75D',
      dark: '#1f2328',
      black: 'black',
    },

    border: {
      light: '#f1f1f1',
      main: '#d9d9d9',
      dark: '#bdbdbd',
      green: '#239047',
    },

    skeleton: {
      background: '#f3f3f3',
      foreground: '#ecebeb',
    },

    navbar: {
      main: 'rgba(57, 181, 74, 0.05)',
      light: '#ECF7ED',
    },

    dropdown: {
      main: 'rgba(42, 193, 126, 0.1)',
    },

    error: {
      light: '#e57373',
      main: '#f5222d',
      dark: '#d32f2f',
      contrastText: '#fff',
    },

    warning: '#FFB818',

    info: '#4169E1',

    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },

  /**
   * Shadows
   */
  shadows: {
    sm: '0 1px 2px 0 rgba(0,0,0,0.05)',
    md: '0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)',
    lg: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)',
    xl: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)',
  },

  /**
   * Breakpoints
   */
  screen: {
    xs: '540px',
    sm: '640px',
    md: '1007px',
    lg: '1100px',
    xl: '1230px',
    xxl: '1440px',
  },

  /**
   * Spacing
   */
  spacing: {
    none: '0px',
    xxs: '6px',
    xs: '12px',
    sm: '18px',
    md: '24px',
    lg: '36px',
    xl: '48px',
  },

  /**
   * Border radius
   */
  radius: {
    xs: '4px',
    sm: '6px',
    md: '10px',
    lg: '14px',
    xl: '20px',
    full: '999px',
  },

  /**
   * z-index
   */
  zIndex: {
    xs: 10,
    sm: 20,
    md: 30,
    lg: 40,
    xl: 50,
  },

  /**
   * Transition
   */
  transition: {
    duration: '0.2s',
    fast: '0.15s',
    slow: '0.3s',
  },
};

export { theme };
